import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";

export interface EditBusinessPhoneScreenProps
  extends StackScreenProps<SettingsRootParamList, "EditBusinessPhoneScreen"> {}

export const EditBusinessPhoneScreen = ({
  navigation,
}: EditBusinessPhoneScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { phone = "" } = globalSettings;
  const [value, setValue] = useState(phone || "");

  const isDirty = useMemo(() => {
    return value != phone;
  }, [value, phone]);

  const isValid = useMemo(() => {
    return true;
  }, [value]);

  const handleOnSave = useCallback(async () => {
    if (!isValid) return;
    return updateGlobalSettings({
      phone: value,
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value, isValid]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label="Edit Business Phone" />,
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Business Phone Number"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
      />
    </Page>
  );
};
